var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-10",staticStyle:{"margin":"0 auto"}},[_c('h1',[_vm._v("Utilisateurs")]),_c('hr'),_c('UserTableComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }